module.exports = __webpack_public_path__ + "img/制御工学6_9.eaf812e7.png";